import { Injectable, Injector } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { SalaAtendimentoModel } from '../models';
import { SelectDto } from 'projects/ProjetoBaseAngular/domain/models/select-dto';

@Injectable({
  providedIn: 'root'
})
export class SalaAtendimentoService extends BaseCrudService<SalaAtendimentoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'SalaAtendimento';
  }

  getSelectList(): Observable<SelectDto[]> {
    return this
      .httpClient
      .get<SalaAtendimentoModel>(`${this.getApiUrl()}${this.getController()}/GetSelectList`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
